function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M336.12,319.81h-1.79v2.59h-.83v-7.34h2.75c1.66,0,2.75.88,2.75,2.34S337.68,319.81,336.12,319.81Zm.07-4h-1.86v3.23h1.82c1.21,0,2-.65,2-1.62S337.37,315.82,336.19,315.82Z",
  transform: "translate(-333.3 -271.17)",
  fill: "#ffb6a9"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M343.05,322.4h-.81V317h.81v1.41a2.33,2.33,0,0,1,2.21-1.51v.87h-.06a2.19,2.19,0,0,0-2.15,2.49Z",
  transform: "translate(-333.3 -271.17)",
  fill: "#ffb6a9"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M350.78,322.53a2.84,2.84,0,1,1,2.84-2.85A2.81,2.81,0,0,1,350.78,322.53Zm0-4.95a2,2,0,0,0-2,2.1,2,2,0,0,0,2,2.12,2,2,0,0,0,2-2.1A2,2,0,0,0,350.78,317.58Z",
  transform: "translate(-333.3 -271.17)",
  fill: "#ffb6a9"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M361.25,322.4v-1.09a2.44,2.44,0,0,1-2.08,1.21,2.84,2.84,0,0,1,0-5.66,2.45,2.45,0,0,1,2.08,1.16v-3.28h.81v7.66Zm-1.93-4.81a1.91,1.91,0,0,0-1.91,2.09,2,2,0,0,0,1.91,2.11,2.1,2.1,0,0,0,0-4.2Z",
  transform: "translate(-333.3 -271.17)",
  fill: "#ffb6a9"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M369.48,317h.79v5.42h-.79v-.94a2.09,2.09,0,0,1-1.86,1.06,2,2,0,0,1-2.08-2.18V317h.81v3.17a1.45,1.45,0,0,0,1.5,1.63,1.61,1.61,0,0,0,1.63-1.7Z",
  transform: "translate(-333.3 -271.17)",
  fill: "#ffb6a9"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M376.35,322.53a2.84,2.84,0,1,1,2.17-4.7l-.54.56a2.18,2.18,0,0,0-1.64-.81,2,2,0,0,0-1.94,2.1,2,2,0,0,0,2,2.12,2.25,2.25,0,0,0,1.66-.8l.51.48A2.77,2.77,0,0,1,376.35,322.53Z",
  transform: "translate(-333.3 -271.17)",
  fill: "#ffb6a9"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M384.15,321.82a2.24,2.24,0,0,0,1.71-.76l.51.45a2.81,2.81,0,0,1-2.24,1,2.84,2.84,0,0,1-.1-5.67,2.58,2.58,0,0,1,2.52,2.88,2.36,2.36,0,0,1,0,.25h-4.3A1.91,1.91,0,0,0,384.15,321.82Zm1.59-2.43a1.79,1.79,0,0,0-1.73-1.85,1.88,1.88,0,0,0-1.77,1.85Z",
  transform: "translate(-333.3 -271.17)",
  fill: "#ffb6a9"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M393.93,322.4v-1.09a2.44,2.44,0,0,1-2.08,1.21,2.84,2.84,0,0,1,0-5.66,2.45,2.45,0,0,1,2.08,1.16v-3.28h.81v7.66ZM392,317.59a1.91,1.91,0,0,0-1.91,2.09,2,2,0,0,0,1.91,2.11,2.1,2.1,0,0,0,0-4.2Z",
  transform: "translate(-333.3 -271.17)",
  fill: "#ffb6a9"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M407,322.52a2.45,2.45,0,0,1-2.08-1.16v1h-.8v-7.66h.8v3.33a2.44,2.44,0,0,1,2.08-1.21,2.84,2.84,0,0,1,0,5.66Zm-.15-4.93a2.1,2.1,0,0,0,0,4.2,1.91,1.91,0,0,0,1.91-2.1A2,2,0,0,0,406.84,317.59Z",
  transform: "translate(-333.3 -271.17)",
  fill: "#ffb6a9"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M415.27,322.58c-.46,1.12-1,1.53-1.81,1.53a2.44,2.44,0,0,1-1.15-.27l.27-.64a1.81,1.81,0,0,0,.85.2c.49,0,.79-.25,1.11-1l-2.46-5.4H413l2,4.52,1.74-4.52h.86Z",
  transform: "translate(-333.3 -271.17)",
  fill: "#ffb6a9"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M466.66,311.11a.24.24,0,0,0-.24.24v10.39l-7.79-10.39c-.08-.1-.16-.24-.34-.24a.24.24,0,0,0-.24.24v11a.24.24,0,1,0,.48,0h0V312l7.75,10.37,0,0c.08.11.16.24.35.24a.24.24,0,0,0,.24-.24h0v-11h0A.24.24,0,0,0,466.66,311.11Z",
  transform: "translate(-333.3 -271.17)",
  fill: "#ffb6a9"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M438.93,322.37l.23-.07-3.83-10.95c-.05-.13-.12-.24-.25-.24s-.19.11-.24.24h0l-2.54,7.24-2.53-7.24c0-.13-.11-.24-.25-.24s-.19.11-.24.24h0l-3.83,10.95h0a.26.26,0,0,0,0,.11.23.23,0,0,0,.23.23.27.27,0,0,0,.26-.2h0l3.61-10.38,2.53,7.25-1,3h0a.26.26,0,0,0,0,.11.23.23,0,0,0,.23.23.28.28,0,0,0,.26-.2h0l.83-2.4.84,2.4h0a.27.27,0,0,0,.26.2.23.23,0,0,0,.23-.23.26.26,0,0,0,0-.11l-.23.07.23-.07-1-3,2.52-7.25,3.62,10.38h0a.26.26,0,0,0,.25.2.22.22,0,0,0,.23-.23.23.23,0,0,0,0-.11Z",
  transform: "translate(-333.3 -271.17)",
  fill: "#ffb6a9"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M452.87,322.37l.23-.07-4.67-10.95c-.05-.13-.11-.24-.24-.24s-.2.11-.25.24h0l-4.67,10.95h0a.23.23,0,0,0,0,.11.22.22,0,0,0,.23.23.26.26,0,0,0,.25-.2h0l1.34-3.17h6.23l1.34,3.17h0a.28.28,0,0,0,.26.2.23.23,0,0,0,.23-.23.26.26,0,0,0,0-.11Zm-1.77-3.53h-5.84l2.93-6.91,2.93,6.91Z",
  transform: "translate(-333.3 -271.17)",
  fill: "#ffb6a9"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M481.31,322.37l.23-.07-4.67-10.95c-.05-.13-.11-.24-.25-.24s-.19.11-.24.24h0l-4.67,10.95h0a.26.26,0,0,0,0,.11.23.23,0,0,0,.23.23.27.27,0,0,0,.26-.2h0l1.34-3.17h6.23l1.34,3.17h0a.26.26,0,0,0,.25.2.22.22,0,0,0,.23-.23.23.23,0,0,0,0-.11Zm-1.77-3.53h-5.85l2.93-6.91,2.93,6.91Z",
  transform: "translate(-333.3 -271.17)",
  fill: "#ffb6a9"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M507.76,322.3l-.23.07.23-.07-4.67-10.95c0-.13-.11-.24-.25-.24s-.19.11-.24.24h0l-4.67,10.95h0a.26.26,0,0,0,0,.11.23.23,0,0,0,.23.23.27.27,0,0,0,.26-.2h0l1.34-3.17H506l1.34,3.17h0a.26.26,0,0,0,.25.2.22.22,0,0,0,.23-.23A.23.23,0,0,0,507.76,322.3Zm-2-3.46h-5.85l2.93-6.91,2.93,6.91Z",
  transform: "translate(-333.3 -271.17)",
  fill: "#ffb6a9"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M491.06,316.76a2.69,2.69,0,0,0,2.36-2.77c0-1.87-1.19-2.88-3.37-2.88h-3.67a.26.26,0,0,0-.25.26v11a.24.24,0,0,0,.48,0h0v-5.55h3.51a.59.59,0,0,1,.24,0c1.84.86,3,3.75,3,5.44v.07a.24.24,0,0,0,.48,0v-.07A7.78,7.78,0,0,0,491.06,316.76ZM493,314c0,2.17-2.08,2.43-2.95,2.43h-3.39v-4.87H490C491.93,311.55,493,312.38,493,314Z",
  transform: "translate(-333.3 -271.17)",
  fill: "#ffb6a9"
});

function SvgAcnalManaraLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 175.28,
    height: 52.94,
    viewBox: "0 0 175.28 52.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M389.81,301a15,15,0,0,1-18.45-14.38c-.14-8.49,6.08-15.45,14.78-15.45a15.11,15.11,0,0,1,11.19,4.44.3.3,0,0,1,0,.41l-1.87,2a.28.28,0,0,1-.4,0,12.55,12.55,0,0,0-9-3.81c-6.47,0-11.31,5.22-11.31,12s4.88,12.11,11.31,12.11c3.91,0,6.51-1.47,9.24-4a.27.27,0,0,1,.39,0l1.77,1.73a.28.28,0,0,1,0,.41A15.58,15.58,0,0,1,389.81,301ZM433,271.67h2.64a.29.29,0,0,1,.29.29v28.67a.27.27,0,0,1-.28.27h-2.17a.36.36,0,0,1-.29-.14l-18.44-23.41a.18.18,0,0,0-.32.11v23.15a.29.29,0,0,1-.29.29h-2.64a.29.29,0,0,1-.29-.29V272a.27.27,0,0,1,.28-.28h2.63a.37.37,0,0,1,.29.14l18,22.87a.18.18,0,0,0,.32-.11V272A.29.29,0,0,1,433,271.67Zm43.81,29.23h-2.91a.3.3,0,0,1-.27-.17l-3.25-7.35a.35.35,0,0,0-.32-.21H454.58a.33.33,0,0,0-.31.21l-3.3,7.35a.3.3,0,0,1-.27.17H448a.3.3,0,0,1-.26-.41l13-28.81a.38.38,0,0,1,.34-.22h2.61a.38.38,0,0,1,.34.22l13,28.81A.29.29,0,0,1,476.79,300.9Zm-14.65-25.17-6.36,14.2a.2.2,0,0,0,.18.28h12.7a.2.2,0,0,0,.18-.28l-6.32-14.2A.21.21,0,0,0,462.14,275.73ZM362.43,300.9h-2.92a.3.3,0,0,1-.26-.17L356,293.38a.34.34,0,0,0-.31-.21H340.22a.35.35,0,0,0-.32.21l-3.3,7.35a.28.28,0,0,1-.26.17h-2.75a.29.29,0,0,1-.26-.41l13-28.81a.37.37,0,0,1,.33-.22h2.62a.37.37,0,0,1,.33.22l13,28.81A.29.29,0,0,1,362.43,300.9Zm-14.65-25.17-6.36,14.2a.2.2,0,0,0,.18.28h12.7a.2.2,0,0,0,.18-.28l-6.32-14.2A.21.21,0,0,0,347.78,275.73Zm141.35-4.06h2.72a.29.29,0,0,1,.29.29v25.69a.2.2,0,0,0,.2.2h16a.29.29,0,0,1,.29.29v2.47a.29.29,0,0,1-.29.29H489.13a.29.29,0,0,1-.29-.29V272A.29.29,0,0,1,489.13,271.67Z",
    transform: "translate(-333.3 -271.17)",
    fill: "#00b2db",
    style: {
      mixBlendMode: "multiply"
    }
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcnalManaraLogo);
export default __webpack_public_path__ + "static/media/ACNAL_MANARA_logo.9a922175.svg";
export { ForwardRef as ReactComponent };